export const patientNameRegex = /^[A-Za-z0-9_\-'.]+( [A-Za-z0-9_\-'.]+)*$/;
export const numAlphabetOnlyRegex = /^[A-Za-z0-9]*$/;
export const alphabetSpaceAndHyphen = /[^a-zA-Z\s-]/g;
export const onlyNumAlphabetRegex = /[^A-Za-z0-9]/g;